/**
 * member
 */
'use strict';
import AppMember from '@/_modules/app_member';

document.addEventListener('DOMContentLoaded', () => {
  new AppMember();
}, false);

window.addEventListener('load', () => {
}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
